import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  Card,
  Checkbox,
  Divider,
  FormControlLabel,
  IconButton,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  styled,
} from "@mui/material";
import {
  AccessTime,
  AccessTimeFilled,
  ArrowBack,
  CalendarMonth,
  CalendarMonthRounded,
  CalendarToday,
  ConfirmationNumber,
  Event,
  Person,
} from "@mui/icons-material";
import {
  addDays,
  addHours,
  addMinutes,
  differenceInMinutes,
  eachMinuteOfInterval,
  format,
  isSameDay,
  isSameHour,
  isSameMinute,
  isValid,
  isWithinInterval,
  parse,
  subDays,
  parseISO,
  getYear,
  getMonth,
  getDate,
  getHours,
  getMinutes,
  set,
  startOfDay,
  endOfDay,
  isAfter,
  isBefore,
  differenceInDays,
  addWeeks,
  differenceInWeeks,
  addMonths,
  differenceInMonths,
  addYears,
  differenceInYears,
} from "date-fns";
import { gql, useMutation, useQuery } from "@apollo/client";
import HourFormat from "../../util/hourFormat";
import Error from "../Error";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
import { addBookings, SEND_EMAIL_MUTATION } from "../../graphql/mutations";
import {
  getBookings,
  getCompanyHours,
  getInviteeAnswers,
  getInviteeQuestions,
  getOverrideGroups,
  getOverrides,
  getUsers,
} from "../../graphql/querys";
import moment from "moment-timezone";
import { Timezones_List } from "../../util/timezones";


const NotFound = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        height: "100%",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div>
        <h1>This Booking Page was either taken or Invalid</h1>
        <p>The requested page could not be found.</p>
      </div>
    </div>
  );
};

const Next = styled((props) => (
  <Button
    variant="contained"
    style={{
      background: "#d9bca9",
      fontWeight: 700,
    }}
    {...props}
  />
))({
  color: "white",
  borderRadius: "30px",
  height: "50px",
  background: "rgb(0,105,255)",
  boxShadow: "none",
  maxWidth: "170px",
  marginTop: "40px",
  alignItems: "center",
  display: "flex",
});

function BookPage(props) {
  const [addBooking] = useMutation(addBookings);
  const [sendEmail] = useMutation(SEND_EMAIL_MUTATION);
  const { id, user } = useParams();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const data = props.all.find((obj) => obj.link == id);
  const {
    loading: userssLoading,
    error: userssError,
    data: userssData,
  } = useQuery(getUsers, {
    variables: { url: user },
  });

  // Skip the other queries if userssData is not ready
  const skipOtherQueries = userssLoading || !userssData;
  const {
    loading: questionLoading,
    error: questionError,
    data: questionData,
    refetch: questionRefetch,
  } = useQuery(getInviteeQuestions, {
    variables: {
      eventId: parseInt(data.id),
    },
    skip: skipOtherQueries,
  });

  const {
    loading: answerLoading,
    error: answerError,
    data: answerData,
    refetch: answerRefetch,
  } = useQuery(getInviteeAnswers, {
    variables: {
      eventId: parseInt(data.id),
    },
    skip: skipOtherQueries,
  });

  // Assuming you get userId from userssData
  const userId = parseInt(
    userssData && userssData.users && userssData.users[0].id
  );
  const {
    loading,
    error,
    data: companyData,
    refetch,
  } = useQuery(getCompanyHours, {
    variables: {
      userId: userId, // The userId you got from the first query
      hours24: HourFormat(),
    },
    skip: skipOtherQueries || !userId, // Directly check if userId is undefined
  });
  const {
    loading: bookloading,
    error: bookerror,
    data: bookdata,
  } = useQuery(getBookings, { skip: skipOtherQueries });

  const {
    loading: overrideGroupLoading,
    error: overrideGroupError,
    data: overrideGroupData,
    refetch: overrideGroupRefetch,
  } = useQuery(getOverrideGroups, {
    variables: {
      userId: userId, // The userId you got from the first query
    },
    skip: skipOtherQueries,
  });

  const {
    loading: overrideLoading,
    error: overrideError,
    data: overrideData,
    refetch: overrideRefetch,
  } = useQuery(getOverrides, {
    variables: {
      userId: userId, // The userId you got from the first query
    },
    skip: skipOtherQueries,
  });
  const { time } = useParams();
  const selectedDate = zonedTimeToUtc(
    new Date(time),
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  const navigate = useNavigate();
  const [answer, setAnswer] = useState([]);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    setErrors(questionData?.getInviteeQuestions.map(() => false));
  }, [questionLoading]);
  const [times, setTimes] = useState(null);
  const totalLoading =
    userssLoading ||
    loading ||
    bookloading ||
    overrideGroupLoading ||
    overrideLoading ||
    questionLoading ||
    answerLoading;
  useEffect(() => {
    if (!totalLoading) {
      theOne = overrideGroupData?.getOverrideGroups.find((val) => {
        return (
          isSameDay(new Date(selectedDate), new Date(val.date)) &&
          val.groupId == data.groupId
        );
      });
      find = theOne
        ? overrideData?.getOverrides
          .filter((val) => val.groupId == theOne.id)
          .map((val) => {
            return {
              day: format(new Date(theOne.date), "EEEE"),
              groupId: theOne.groupId,
              userId: props.usersData.id,
              startTime: val.startTime,
              endTime: val.endTime,
              id: val.id,
              onJob: true,
            };
          })
        : companyData?.getCompanyHours.filter(
          (obj) =>
            obj.day === format(selectedDate, "EEEE") &&
            data.groupId == obj.groupId
        ) || {};
      find = find.filter(
        (date, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              t.startTime.toLowerCase() == date.startTime.toLowerCase() &&
              t.endTime.toLowerCase() == date.endTime.toLowerCase()
          )
      );
      let tempTimesyest = [];
      let tempTimes = [];
      let tempTimestmrw = [];
      for (let i = 0; i < find.length; i++) {
        findTimes(tempTimes, find[i].startTime, find[i].endTime, selectedDate);
      }
      for (let i = 0; i < getData(subDays(selectedDate, 1)).length; i++) {
        var dataa = getData(subDays(selectedDate, 1));
        tempTimesyest = findTimes(
          tempTimesyest,
          dataa[i].startTime,
          dataa[i].endTime,
          subDays(selectedDate, 1),
          1
        );
      }

      for (let i = 0; i < getData(addDays(selectedDate, 1)).length; i++) {
        var dataa = getData(addDays(selectedDate, 1));
        tempTimestmrw = findTimes(
          tempTimestmrw,
          dataa[i].startTime,
          dataa[i].endTime,
          addDays(selectedDate, 1),
          1
        );
      }
      tempTimesyest.map((val) =>
        tempTimes.push(
          format(
            parse(
              val,
              val.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
              new Date()
            ),
            "h:mmaa"
          ).toLowerCase()
        )
      );
      tempTimestmrw.map((val) =>
        tempTimes.push(
          format(
            parse(
              val,
              val.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
              new Date()
            ),
            "h:mmaa"
          ).toLowerCase()
        )
      );
      setTimes(
        [...new Set(tempTimes)].map((val) =>
          format(parse(val, "h:mmaa", new Date()), HourFormat()).toLowerCase()
        )
      );
    }
  }, [totalLoading]);
  const totalError =
    questionError ||
    answerError ||
    userssError ||
    bookerror ||
    error ||
    overrideError ||
    overrideGroupError;
  if (totalLoading) {
    return "Loading";
  } else if (totalError) {
    return <Error />;
  } else if (!isValid(parseISO(time))) {
    console.log('here')
    return <NotFound />;
  }
  const handleChange = (setState) => (event) => {
    setState(event.target.value);
  };
  const userTimezone = moment.tz.guess();

  // Get the abbreviated timezone name (e.g., PDT, EST, etc.)
  const timezoneAbbr = moment.tz(userTimezone).zoneAbbr();

  // Get the full timezone name (e.g., Pacific Daylight Time, Eastern Standard Time, etc.)
  const timezoneName = moment.tz(userTimezone).zoneName();

  // Format the timezone in the desired format
  const formattedTimezone = `${timezoneName} - ${timezoneAbbr}`;
  function handleConfirmation() {
    const newErrors = [];
    var email = "";
    var name = "";
    // Validate each question
    questionData.getInviteeQuestions.forEach((question, index) => {
      const answerForQuestion = answer.find(
        (answer) => answer.questionId === question.id
      );
      if (question.required && !answerForQuestion) {
        newErrors[index] = true;
        return;
      } else {
        newErrors[index] = false;
      }

      email =
        question.title.toLowerCase() === "email"
          ? answerForQuestion.answer[0]
          : email;
      console.log(answer)
      console.log(answerForQuestion)
      name =
        question.title.toLowerCase() === "name"
          ? answerForQuestion.answer[0]
          : name;
    });

    setErrors(newErrors);
    const hasErrors = newErrors.includes(true);

    const userTimezone = moment.tz.guess();

    // Format the timezone in the desired format
    const formattedTimezone = moment.tz(userTimezone).format("z [Time] - Z");

    if (!hasErrors) {
      addBooking({
        variables: {
          input: {
            eventId: parseInt(data.id),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            bookingId: uuidv4(),
            time: zonedTimeToUtc(
              new Date(time),
              Intl.DateTimeFormat().resolvedOptions().timeZone
            ).toString(),
            status: data.bookingApproval ? "Pending" : null,
            answers: answer.map((val) => {
              return {
                questionId: parseInt(val.questionId),
                answer: val.answer,
              };
            }),
          },
        },
      })
        .then((res) => {
          const from = format(new Date(time), "hh:mmaa")
          const date = format(new Date(time), "iiii, MMMM do, yyyy")
          const emailData = {
            to: email, // The recipient's email address
            subject: "Booking Confirmation", // Email subject
            text: `Hi ${name},\n\n Your  ${data.length} Minute Meeting with  ${userssData.users[0].username} at ${from} on   ${date} is scheduled..`, // Email text
           };

          sendEmail({
            variables: {
              ...emailData
            },
          })
            .then((response) => {
              // Handle success response
              console.log(response.data.sendEmail);
            })
            .catch((error) => {
              // Handle error
              console.error("Email sending error:", error);
            });
          navigate(
            `/${userssData.users[0].url}/events/invitees/${res.data.addBooking.bookingId}/confirmed`
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  var theOne = overrideGroupData?.getOverrideGroups.find((val) => {
    return (
      isSameDay(new Date(selectedDate), new Date(val.date)) &&
      val.groupId == data.groupId
    );
  });
  var find = theOne
    ? overrideData?.getOverrides
      .filter((val) => val.groupId == theOne.id)
      .map((val) => {
        return {
          day: format(new Date(theOne.date), "EEEE"),
          groupId: theOne.groupId,
          userId: parseInt(props.usersData.id),
          startTime: val.startTime,
          endTime: val.endTime,
          id: val.id,
          onJob: true,
        };
      })
    : companyData?.getCompanyHours.filter(
      (obj) =>
        obj.day === format(selectedDate, "EEEE") &&
        data.groupId == obj.groupId
    ) || {};
  function getData(date) {
    var theOne = overrideGroupData?.getOverrideGroups.find((val) => {
      return (
        isSameDay(new Date(date), new Date(val.date)) &&
        val.groupId == data.groupId
      );
    });
    return theOne
      ? overrideData?.getOverrides
        .filter((val) => val.groupId == theOne.id)
        .map((val) => {
          return {
            day: format(new Date(theOne.date), "EEEE"),
            groupId: theOne.groupId,
            userId: parseInt(props.usersData.id),
            startTime: val.startTime,
            endTime: val.endTime,
            id: val.id,
            onJob: true,
          };
        })
      : companyData?.getCompanyHours.filter(
        (obj) =>
          obj.day === format(date, "EEEE") && data.groupId == obj.groupId
      ) || {};
  }
  function getTimezoneInfo(timezone) {
    return Timezones_List.find((val) => val.id == timezone);
  }

  function findit(e, fornows) {
    var count = 0;
    for (let i = 0; i < fornows.length; i++) {
      if (
        new Date(fornows[i].time).getFullYear() == e.getFullYear() &&
        new Date(fornows[i].time).getDate() == e.getDate() &&
        new Date(fornows[i].time).getHours() == e.getHours() &&
        new Date(fornows[i].time).getMinutes() == e.getMinutes()
      ) {
        count++;
      }
    }
    return count
      ? data?.maxInvitees
        ? data?.maxInvitees - count <= 0
          ? false
          : data?.maxInvitees - count
        : count
      : false;
  }
  function checks(time, selectedDatee) {
    var actualTime = new Date(selectedDatee || selectedDate).setHours(
      parse(
        time,
        HourFormat(),
        new Date(selectedDatee || selectedDate)
      ).getHours(),
      parse(
        time,
        HourFormat(),
        new Date(selectedDatee || selectedDate)
      ).getMinutes()
    );
    actualTime = new Date(actualTime);
    var fornows = bookdata.getBookings.filter(
      (obj) =>
        new Date(actualTime).getFullYear() ===
        new Date(obj.time).getFullYear() &&
        new Date(actualTime).getDate() === new Date(obj.time).getDate() &&
        new Date(actualTime).getHours() === new Date(obj.time).getHours() &&
        new Date(actualTime).getMinutes() === new Date(obj.time).getMinutes() &&
        obj.eventId == data?.id
    );
    var fornows2 = bookdata.getBookings.filter(
      (obj) =>
        new Date(actualTime).getFullYear() ===
        new Date(obj.time).getFullYear() &&
        new Date(actualTime).getDate() === new Date(obj.time).getDate() &&
        obj.eventId == data?.id
    );
    if (
      data?.eventsPerDay !== null &&
      fornows2?.length &&
      data?.eventsPerDay == fornows2?.length
    ) {
      return "late";
    }
    if (
      differenceInMinutes(parse(time, HourFormat(), new Date()), new Date()) <
      0 &&
      isSameDay(new Date(), new Date(selectedDatee || selectedDate))
    ) {
      return "late";
    }
    if (fornows.length == 0) {
      return data?.maxInvitees ? data?.maxInvitees : true;
    }
    return data?.eventType == "group" ? findit(actualTime, fornows) : "one";
  }
  function getTimezoneInfo(timezone) {
    return Timezones_List.find((val) => val.id == timezone);
  }

  function getTimezoneInfo(timezone) {
    return Timezones_List.find((val) => val.id == timezone);
  }

  function findit(e, fornows) {
    var count = 0;
    for (let i = 0; i < fornows.length; i++) {
      if (
        new Date(fornows[i].time).getFullYear() === e.getFullYear() &&
        new Date(fornows[i].time).getDate() === e.getDate() &&
        new Date(fornows[i].time).getHours() === e.getHours() &&
        new Date(fornows[i].time).getMinutes() === e.getMinutes()
      ) {
        count++;
      }
    }
    return count
      ? data?.maxInvitees
        ? data?.maxInvitees - count <= 0
          ? false
          : data?.maxInvitees - count
        : count
      : false;
  }
  function checks(time, selectedDates) {
    var actualTime = new Date(selectedDates || selectedDate).setHours(
      parse(
        time,
        HourFormat(),
        new Date(selectedDates || selectedDate)
      ).getHours(),
      parse(
        time,
        HourFormat(),
        new Date(selectedDates || selectedDate)
      ).getMinutes()
    );
    actualTime = new Date(actualTime);
    var fornows = bookdata.getBookings.filter(
      (obj) =>
        new Date(actualTime).getFullYear() ===
        new Date(obj.time).getFullYear() &&
        new Date(actualTime).getDate() === new Date(obj.time).getDate() &&
        new Date(actualTime).getHours() === new Date(obj.time).getHours() &&
        new Date(actualTime).getMinutes() === new Date(obj.time).getMinutes() &&
        obj.eventId == data?.id
    );
    var fornows2 = bookdata.getBookings.filter(
      (obj) =>
        new Date(actualTime).getFullYear() ===
        new Date(obj.time).getFullYear() &&
        new Date(actualTime).getDate() === new Date(obj.time).getDate() &&
        obj.eventId == data?.id
    );
    if (
      data?.eventsPerDay !== null &&
      fornows2?.length &&
      data?.eventsPerDay == fornows2?.length
    ) {
      return "late";
    }
    if (
      differenceInMinutes(parse(time, HourFormat(), new Date()), new Date()) <
      0 &&
      isSameDay(new Date(), new Date(selectedDates || selectedDate))
    ) {
      return "late";
    }
    if (fornows.length == 0) {
      return data?.maxInvitees ? data?.maxInvitees : true;
    }
    return data?.eventType == "group" ? findit(actualTime, fornows) : "one";
  }

  function findTimes(arr, start, end, selectedDate, spilled) {
    if (!start || !end) {
      return false;
    }
    var startTime = parse(
      start,
      start.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
      selectedDate
    );
    var endTime = parse(
      end,
      end.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
      selectedDate
    );
    if (isBefore(endTime, startTime)) {
      endTime = addDays(endTime, 1);
    }

    const timestamps = eachMinuteOfInterval({
      start: startTime,
      end: endTime,
    });
    var thirtyMinuteIntervals = timestamps.filter((time, index) => {
      return (
        isWithinInterval(new Date(addMinutes(time, data?.length)), {
          start: startTime,
          end: endTime,
        }) && index % data?.increments === 0
      );
    });
    function convertToUserTime(time, userTimeZone) {
      // convert the time (which is in the company's timezone) to UTC
      const utcTime = zonedTimeToUtc(
        time,
        getTimezoneInfo(props.usersData.timezone).timezone
      );

      // convert the UTC time to the user's timezone
      const userTime = utcToZonedTime(utcTime, userTimeZone);

      // set the date portion of the local time from the userTime date
      const localDate = set(userTime, {
        year: getYear(userTime),
        month: getMonth(userTime),
        date: getDate(userTime),
        hours: getHours(userTime),
        minutes: getMinutes(userTime),
      });

      return localDate;
    }
    var check = [];
    function isTimeWithinSelectedDay(time) {
      return (
        isAfter(time, startOfDay(new Date(selectedDate))) &&
        isBefore(time, endOfDay(new Date(selectedDate)))
      );
    }
    var spilledTimes = [];
    thirtyMinuteIntervals = thirtyMinuteIntervals.filter(
      (date, index, self) =>
        index ==
        self.findIndex((t) => isSameHour(t, date) && isSameMinute(t, date))
    );
    thirtyMinuteIntervals.forEach((time) => {
      const formattedTime = format(
        convertToUserTime(
          time,
          Intl.DateTimeFormat().resolvedOptions().timeZone
        ),
        HourFormat()
      );
      if (
        checks(formattedTime, selectedDate) !== "late" &&
        checks(formattedTime, selectedDate) !== "one" &&
        checks(formattedTime, selectedDate) !== false
      ) {
        const localTime = convertToUserTime(
          time,
          Intl.DateTimeFormat().resolvedOptions().timeZone
        );
        if (isTimeWithinSelectedDay(localTime)) {
          arr.push(format(localTime, "h:mmaa"));
        } else {
          spilledTimes.push(format(localTime, "h:mmaa"));
        }
      }
    });
    if (spilled) {
      return spilledTimes;
    }
  }
  if (!props.isDateGood(new Date(selectedDate))) {
    console.log(new Date(selectedDate))
    return <NotFound />;
  }

  // Parsing the date from the URL
  var selectedDateFromUrl = new Date(selectedDate);
  function differenceInMultiplesOfDays(date1, date2, days) {
    let totalDaysDifference = differenceInDays(date1, date2);
    return Math.round(totalDaysDifference / days);
  }
  function getRecurringDates(end, currentMonth) {
    const parts = end.split(" ");

    const [recurrence, dateString] = parts;

    // Determine frequency (number of days, weeks, etc. between recurrences)
    const frequency = !isNaN(Number(recurrence)) ? Number(recurrence) : 1;

    let dateIncrementFunction;
    let differenceFunction;

    if (!isNaN(Number(recurrence))) {
      // If recurrence is a number, use it as frequency in days
      dateIncrementFunction = (date, val) => addDays(date, val);

      differenceFunction = (date1, date2) =>
        differenceInMultiplesOfDays(date1, date2, frequency);
    } else {
      switch (recurrence) {
        case "day":
          dateIncrementFunction = addDays;
          differenceFunction = differenceInDays;
          break;
        case "week":
          dateIncrementFunction = addWeeks;
          differenceFunction = differenceInWeeks;
          break;
        case "month":
          dateIncrementFunction = addMonths;
          differenceFunction = differenceInMonths;
          break;
        case "year":
          dateIncrementFunction = addYears;
          differenceFunction = differenceInYears;
          break;
        default:
          return [new Date(end)]; // If it's not recurring, return the end date itself
      }
    }

    let dates = [];
    const currentMonthDate = new Date(currentMonth);
    currentMonthDate.setUTCHours(0);

    const startDate = new Date(dateString);
    startDate.setUTCHours(0);
    let difference = differenceFunction(currentMonthDate, startDate);
    for (
      let i = Math.ceil(difference - (1 / frequency) * 44) * frequency;
      i <= Math.ceil(difference + (1 / frequency) * 44) * frequency;
      i += frequency
    ) {
      dates.push(dateIncrementFunction(startDate, i));
    }
    return dates;
  }
  function getEndDate(data) {
    // Split the data.end string into parts
    const parts = data.split(" ");
    // Check if the first part is one of the recurrence keywords
    if (
      ["week", "month", "year", "day"].includes(parts[0]) ||
      parseInt(parts[0]) !== NaN
    ) {
      // If it is, join the rest of the parts back together, convert to a Date object, and return it
      const dateStr = parts[1];
      return new Date(dateStr);
    } else {
      // If it's not one of the keywords, throw an error or return a default value
      // This is up to you to decide, based on what you want to do in this case

      console.log(`Unrecognized recurrence keyword: ${parts[0]}`);
      return new Date(parts[1]);
    }
  }

  var referArrays = times?.map((val) =>
    parse(val, HourFormat(), selectedDateFromUrl)
  );
  console.log(times)
  if (
    times && // Add this extra check
    !referArrays.find(
      (date) =>
        new Date(time).getMinutes() === new Date(date).getMinutes() &&
        new Date(time).getHours() === new Date(date).getHours()
    )
  ) {
    console.log('hrer')
    return <NotFound />;
  }
  const updateAnswer = (questionId, value, checkbox, e) => {
    if (checkbox) {
      setAnswer((prevAnswers) => {
        const prevAnswerIndex = prevAnswers.findIndex(
          (answer) => answer.questionId == questionId
        );

        if (prevAnswerIndex > -1) {
          // Update the existing answer
          const existingAnswer = prevAnswers[prevAnswerIndex].answer;

          if (existingAnswer.length > 0 && value) {
            if (existingAnswer.includes(value)) {
              // Remove the value if it already exists
              const updatedAnswer = existingAnswer.filter(
                (answer) => answer !== value
              );
              return [
                ...prevAnswers.slice(0, prevAnswerIndex),
                { ...prevAnswers[prevAnswerIndex], answer: updatedAnswer },
                ...prevAnswers.slice(prevAnswerIndex + 1),
              ];
            } else {
              // Add the value if it does not exist
              const updatedAnswer = [...existingAnswer, value];
              return [
                ...prevAnswers.slice(0, prevAnswerIndex),
                { ...prevAnswers[prevAnswerIndex], answer: updatedAnswer },
                ...prevAnswers.slice(prevAnswerIndex + 1),
              ];
            }
          } else {
            // If the answer is empty, remove the answer
            return [
              ...prevAnswers.slice(0, prevAnswerIndex),
              { ...prevAnswers[prevAnswerIndex], answer: [] },
              ...prevAnswers.slice(prevAnswerIndex + 1),
            ];
          }
        }

        // Add a new answer
        return [{ questionId, answer: [value] }, ...prevAnswers];
      });
    } else {
      setAnswer((prevAnswers) => {
        const prevAnswerIndex = prevAnswers.findIndex(
          (answer) => answer.questionId == questionId
        );

        if (prevAnswerIndex > -1) {
          // Update the existing answer
          const existingAnswer = prevAnswers[prevAnswerIndex].answer[0];

          if (value) {
            // If answer text is not empty, update the answer
            const updatedAnswer = value;
            return [
              ...prevAnswers.slice(0, prevAnswerIndex),
              { ...prevAnswers[prevAnswerIndex], answer: [updatedAnswer] },
              ...prevAnswers.slice(prevAnswerIndex + 1),
            ];
          } else {
            // If answer text is empty, remove the answer
            return [
              ...prevAnswers.slice(0, prevAnswerIndex),
              ...prevAnswers.slice(prevAnswerIndex + 1),
            ];
          }
        }

        // Add a new answer
        if (value) {
          return [...prevAnswers, { questionId, answer: [value] }];
        } else {
          return prevAnswers;
        }
      });
    }
    if (value === "" && e) {
      setErrors((prevErrors) => ({ ...prevErrors, [questionId]: true }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [questionId]: false }));
    }
  };
  //tion to delete the answer for a specific question ID
  const deleteAnswer = (questionId, value) => {
    setAnswer((prevAnswers) => {
      const prevAnswerIndex = prevAnswers.findIndex(
        (answer) => answer.questionId == questionId
      );

      if (prevAnswerIndex > -1) {
        // Remove the value from the answer array
        const updatedAnswer = prevAnswers[prevAnswerIndex].answer.filter(
          (answer) => answer !== value
        );

        if (updatedAnswer.length === 0) {
          // If answer array is empty, remove the answer
          return [
            ...prevAnswers.slice(0, prevAnswerIndex),
            ...prevAnswers.slice(prevAnswerIndex + 1),
          ];
        }

        // Update the answer array
        return [
          ...prevAnswers.slice(0, prevAnswerIndex),
          {
            ...prevAnswers[prevAnswerIndex],
            answer: updatedAnswer,
          },
          ...prevAnswers.slice(prevAnswerIndex + 1),
        ];
      }

      return prevAnswers;
    });
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Card
        className="event-card"
        style={{
          display: "flex",
          width: "90%",
          maxWidth: selectedDate ? "1000px" : "800px",
          justifyContent: "space-between",
          height: "700px",
        }}
      >
        <div
          style={{
            flex: 1,
            padding: "20px 30px",
            flexDirection: "column",
            display: "flex",
            gap: "0px",
            background: "white",
            zIndex: 2,
          }}
        >
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <IconButton
              onClick={() => {
                navigate(-1);
              }}
              style={{ border: "1px solid lightgrey" }}
            >
              <ArrowBack />
            </IconButton>
            <h4></h4>
          </div>
          <h1 style={{ overflowWrap: "break-word" }}>{data.name}</h1>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              height: "30px",
            }}
          >
            <AccessTimeFilled />
            <h4>
              {data.length > 59
                ? Number((data.length / 60).toFixed(1)) + " hrs"
                : data.length + " mins"}
            </h4>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              height: "60px",
            }}
          >
            <CalendarMonth />
            <h4>
              {format(new Date(time), HourFormat()).toLowerCase() +
                " - " +
                format(
                  addMinutes(new Date(time), data.length),
                  HourFormat()
                ).toLowerCase()}
            </h4>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              height: "50px",
            }}
          >
            <Event />
            <h4>{format(new Date(time), "EEEE, MMMM d, yyyy")}</h4>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              height: "50px",
            }}
          >
            <Person />
            <h4>Made by {userssData.users[0].username}</h4>
          </div>
        </div>
        <Divider orientation="vertical" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            flex: selectedDate ? 2 : 2,
            padding: "20px",
            paddingRight: selectedDate ? 0 : "20px",
            overflow: "auto",
          }}
        >
          <h3 style={{ height: "10px" }}>Enter Details</h3>
          {questionData.getInviteeQuestions.map((val, ind) => (
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <h4 className="input-label">
                  {`${val.title} ${val.required ? "*" : ""}`}
                </h4>
              </div>
              {val.type.toLowerCase().includes("radio") ? (
                <>
                  <RadioGroup
                    value={
                      answer?.find((answer) => answer.questionId == val.id)
                        ?.answer[0] || ""
                    }
                    onChange={(event) =>
                      updateAnswer(val.id, event.target.value, "", val.required)
                    }
                    className="flex column "
                  >
                    {answerData.getInviteeAnswers
                      .filter((vall) => vall.questionId == val.id)
                      .map((val) => (
                        <FormControlLabel
                          value={val.title}
                          control={<Radio />}
                          label={val.title}
                        />
                      ))}
                  </RadioGroup>
                  {errors[ind] && (
                    <div className="error-message">Please select an option</div>
                  )}
                </>
              ) : val.type.toLowerCase().includes("checkbox") ? (
                <div className="flex column ">
                  {answerData.getInviteeAnswers
                    .filter((vall) => vall.questionId == val.id)
                    .map((vall) => {
                      return (
                        <FormControlLabel
                          key={vall.id}
                          value={vall.title}
                          control={
                            <Checkbox
                              checked={
                                answer
                                  ?.find(
                                    (answer) => answer.questionId == val.id
                                  )
                                  ?.answer?.includes(vall.title) || false
                              }
                              onChange={(event) => {
                                if (event.target.checked) {
                                  updateAnswer(
                                    val.id,
                                    vall.title,
                                    true,
                                    val.required
                                  );
                                } else {
                                  deleteAnswer(val.id, vall.title);
                                }
                              }}
                            />
                          }
                          label={vall.title}
                        />
                      );
                    })}
                  {errors[ind] && (
                    <div className="error-message">Please select an option</div>
                  )}
                </div>
              ) : val.type.toLowerCase().includes("drop") ? (
                <Select
                  fullWidth
                  sx={{
                    "& .MuiSelect-select .notranslate::after": true
                      ? {
                        content: `"Select..."`,
                        opacity: 0.42,
                      }
                      : {},
                  }}
                  value={
                    answer?.find((answer) => answer.questionId == val.id)
                      ?.answer[0] || ""
                  }
                  error={errors[val.id]}
                  onChange={(event) =>
                    updateAnswer(val.id, event.target.value, "", val.required)
                  }
                >
                  {answerData.getInviteeAnswers
                    .filter((vall) => vall.questionId == val.id)
                    .map((val) => (
                      <MenuItem value={val.title}>{val.title}</MenuItem>
                    ))}
                </Select>
              ) : (
                <OutlinedInput
                  onChange={(event) =>
                    updateAnswer(val.id, event.target.value, "", val.required)
                  }
                  value={
                    answer?.find((answer) => answer.questionId == val.id)
                      ?.answer[0]
                  }
                  multiline={val.type.toLowerCase().includes("multi")}
                  variant="outlined"
                  id="title"
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                  }}
                  error={errors[ind] || false}
                />
              )}
            </div>
          ))}
          {/*  <div>
             <div style={{ display: "flex", alignItems: "center" }}>
              <h4 className="input-label">Email *</h4>
             </div>
           <OutlinedInput
             onChange={handleChange(setEmail)}
               value={email}
               variant="outlined"
                 error={errors[0]}
               id="title"
              style={{
                width: "100%",
               maxWidth: "500px",
              }}
            />
         */}
          <Next onClick={handleConfirmation}>Schedule Event</Next>
        </div>
        {/* Add your custom content here */}
      </Card>
    </div>
  );
}

export default BookPage;
